function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M7.889 6.426l-.014.012-4.14-4.14a1.017 1.017 0 10-1.437 1.437l4.009 4.01L6 8H3a1 1 0 00-1 1v6a1 1 0 001 1h3l5.18 4.317a.5.5 0 00.82-.384v-6.496l2 2V16c.179 0 .355-.012.528-.034l1.633 1.633c-.67.259-1.399.401-2.161.401v2a7.966 7.966 0 003.672-.89l2.593 2.592a1.017 1.017 0 101.437-1.437L19.37 17.93l.013-.012-1.417-1.416a.753.753 0 00-.013.012l-1.419-1.42.014-.01-1.427-1.427-.015.01L12 10.563v-.026l-2-2v.026l-.705-.705.014-.012-1.42-1.42zM14 9.663l3.745 3.745A4 4 0 0014 8v1.663zm5.248 5.248l1.456 1.456A8 8 0 0014 4v2a6 6 0 015.248 8.91zM12 7.663L9.457 5.119l1.723-1.436a.5.5 0 01.82.385v3.595zM6.724 10l1.003-.836L10 11.437v5.293L6.724 14H4v-4h2.724z"
});

var SvgVolumeOff = function SvgVolumeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none"
  }), _ref);
};

export default SvgVolumeOff;